export default "__VITE_ASSET__CBP$N0_E__"